<template>
  <q-scroll-area style="height: calc(100vh - 420px) !important">
    <div v-if="gridData.length > 0" class="q-px-md">
      <q-card
        bordered
        flat
        class="q-pa-md q-my-md"
        v-for="(division, index) in gridData"
        :key="`event_${index}`"
      >
        <b>{{ division.division_name }}</b> <br />
        <datatable
          :filter="search"
          :flat="true"
          :data="division.data"
          :columns="[
            {
              name: 'name',
              label: 'Name',
              field: 'name',
              align: 'left',
              style:
                'min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
              sortable: true,
            },
            {
              name: 'association_abbr',
              label: 'Club',
              field: 'association_abbr',
              align: 'left',
              style:
                'min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
              sortable: true,
            },
            {
              name: 'points',
              label: 'Points',
              field: 'points',
              align: 'left',
              style:
                'min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;',
              sortable: true,
            },
          ]"
          @rowDoubleClick="handleDoubleClick"
        >
          <template slot="body-cell-association_abbr" slot-scope="data">
            <q-td :props="data.props">
              <q-img
                v-if="data.props.row.capUrl"
                :src="data.props.row.capUrl"
                width="40px"
                contain
                class="q-ml-sm"
              >
              </q-img>
              {{ data.props.row.association_abbr }}
            </q-td>
          </template>
        </datatable>
      </q-card>
    </div>
  </q-scroll-area>
</template>

<script>
  import datatable from "@/components/datatable/datatable.vue";

  export default {
    props: {
      gridData: [],
      search: {
        default: "",
        type: String,
      },
    },
    components: {
      datatable,
    },
    data() {
      return {
        columns: [
          {
            name: "association_abbr",
            label: "CLUB",
            align: "left",
            field: "association_abbr",
            sortable: true,
          },
          {
            name: "points",
            label: "Points",
            align: "right",
            field: "points",
            format: (val) => (val ? val : 0),
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
        ],
      };
    },
    methods: {
      handleDoubleClick(row) {
        console.log(row);
      },
    },
  };
</script>

<style>
</style>template
